<template>
  <q-dialog
    ref="dialog"
    @hide="onDialogHide"
  >
    <q-card class="q-pa-sm">
      <q-card-section class="row">
        <div class="text-h6 ellipsis">
          {{ $t('run.collectData.waitForSessionControl.title') }}
        </div>
      </q-card-section>
      <q-card-section>
        <p>
          {{ $t('run.collectData.waitForSessionControl.textCaption',
                { sessionRunByName: runByName }) }}
        </p>
      </q-card-section>
      <q-card-actions
        align="center"
      >
        <q-btn
          flat
          :label="$t('run.collectData.waitForSessionControl.btnForceControlLabel')"
          :loading="forceControlSpinner"
          color="primary"
          @click="onForceControl"
        />
      </q-card-actions>
      <q-card-actions align="right">
        <q-btn
          v-close-popup
          flat
          :label="$t('common.buttonCancel')"
          color="secondary"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import {
  get,
} from 'lodash';
import { mapState } from 'pinia';
import { notifyNegative, notifySuccess } from 'src/composables/interactions';
import { auth } from 'src/store/auth';
import { sessions } from 'src/store/sessions';

export default {
  name: 'WaitForSessionControl',

  emits: ['ok', 'hide'],

  data() {
    return {
      forceControlSpinner: false,
    };
  },

  computed: {
    ...mapState(auth, ['userDetails']),
    ...mapState(sessions, ['activeSession']),

    runByName() {
      return get(this.activeSession, 'runByName', '');
    }, // runByName()
  },

  watch: {
    activeSession: {
      deep: true,
      handler(newSession) {
        if (get(newSession, 'runBy') === this.userDetails.userId) {
          this.requestGranted();
        } else if (get(newSession, 'requestControl') === null) {
          this.requestDenied();
        }
      },
    },

  },

  methods: {

    async onForceControl() {
      this.forceControlSpinner = true;
      this.$emit('ok');
    }, // onSubmitForm()

    show() {
      this.$refs.dialog.show();
    },

    hide() {
      if (this.$refs.dialog) {
        this.$refs.dialog.hide();
      }
    },

    onDialogHide() {
      this.$emit('hide');
    },

    requestGranted() {
      notifySuccess(this.$t('run.collectData.waitForSessionControl.notifyRequestGranted'));

      this.$refs.dialog.hide();
    }, // requestGranted()

    requestDenied() {
      notifyNegative(this.$t('run.collectData.waitForSessionControl.notifyRequestDenied'));

      this.$refs.dialog.hide();
    }, // requestDenied()

  },
};
</script>
